import block from 'bem-cn'
import React, { FC, useMemo } from 'react'

import { IUserPromotion } from 'shared/models/Promotion'

import './BonusProgress.scss'

interface IBonusProgressProps {
  promotion: IUserPromotion
  needToWinBackText: string
  className?: string
  promotionIsExpired: boolean
}

const b = block('bonus-progress')

export const BonusProgress: FC<IBonusProgressProps> = ({
  promotion,
  promotionIsExpired,
  className,
  needToWinBackText,
}) => {
  const progress = useMemo(() => promotion.wagerComplete / (promotion.wager / 100) || 0, [promotion])

  return (
    <>
      {!promotionIsExpired ? (
        <div className={b('wrapper').mix(className)}>
          <div className={b()}>
            <span className={b('line')} style={{ width: `${progress}%` }} />
          </div>
          <div className={b('bottom-text')}>
            <span className={b('value', { current: true })} style={{ left: `${progress}%` }}>
              {promotion.wagerComplete}
            </span>
            <div>
              <span className={b('need-to-win-text')}>{needToWinBackText}</span> {promotion.wager}{' '}
              {promotion.wagerCurrency}
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}
